import axios from 'axios';
import { toastHandler } from '@/api/utilities';

const doGetReferrals = async (payload) => {
  return toastHandler(axios.get('/user/referrals/list'), false);
};

export { doGetReferrals };
